export const is4xxError = (statusCode?: number | null) => {
	return statusCode && statusCode >= 400 && statusCode < 500;
};

export const getStatusCodeGroup = (statusCode?: number | null): string => {
	if (statusCode) {
		if (statusCode >= 100 && statusCode < 200) return '1xx';
		if (statusCode >= 300 && statusCode < 400) return '3xx';
		if (statusCode >= 400 && statusCode < 500) return '4xx';
		if (statusCode >= 500 && statusCode < 600) return '5xx';
	}

	return 'unknown';
};
